import { validateMapperSearch } from '@hyperguest/widgets/hyperguest-mapper';
import { validateSearchSearch as validateHyperguestSearchSearch } from '@hyperguest/widgets/hyperguest-search';
import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { protectedRoute } from './_root';

export const managementHyperguestMapperRoute = createRoute({
  getParentRoute: () => protectedRoute,
  path: 'management/hyperguest/mapper',
  component: lazyRouteComponent(() =>
    import('@hyperguest/pages/hyperguest-mapper').then((m) => ({
      default: m.HyperguestMapperPage,
    }))
  ),
  validateSearch: validateMapperSearch,
});

export const managementHyperguestSearchRoute = createRoute({
  getParentRoute: () => protectedRoute,
  path: 'management/hyperguest/search',
  component: lazyRouteComponent(() =>
    import('@hyperguest/pages/hyperguest-search').then((m) => ({
      default: m.HyperguestSearchPage,
    }))
  ),
  validateSearch: validateHyperguestSearchSearch,
});
